/**
 * Copyright (c) 2025 Lauft App Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react';
import Conversations from '../common/Conversations';

const AgentConversations = ({ agentInfo, onInvitations }) => {
  const [theme, setTheme] = useState('light');

  // Detect theme from localStorage (same as AgentLayout)
  useEffect(() => {
    const saved = localStorage.getItem('agent-theme');
    setTheme(saved === 'dark' ? 'dark' : 'light');
    
    // Listen for storage changes to sync theme across tabs
    const handleStorageChange = (e) => {
      if (e.key === 'agent-theme') {
        setTheme(e.newValue === 'dark' ? 'dark' : 'light');
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return <Conversations theme={theme} onNavigateToUserManagement={onInvitations} />;
};

export default AgentConversations;